
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0.53125 0.53125L5.53125 5.53125L10.5312 0.531251","stroke":"#555555","stroke-width":"1.5"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  